// extracted by mini-css-extract-plugin
module.exports = {"dropdown-option-label":"select-tabs_dropdown-option-label__83MSo","is-selected":"select-tabs_is-selected__cNhFE","select-label":"select-tabs_select-label__2E4JF"};